import { useEffect, useState } from "react";
import { PhotoIcon } from "@heroicons/react/24/solid";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { baseUrl } from "../../../Environments/environment";
import { useAuth } from "../../../Contexts/AuthContext/AuthContext";
import { toast } from "react-toastify";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useLocation, useNavigate } from "react-router-dom";
import { apiClient } from "../../../api";
import {
  Delete,
  DeleteIcon,
  LucideDelete,
  Trash,
  TrashIcon,
} from "lucide-react";
import { BUSINESS_TYPES } from "../../../utils/businessTypes";

const steps = [
  { name: "Business SMS Subaccount", href: "#", status: "complete" },
  { name: "Business Phone Number", href: "#", status: "current" },
  { name: "Integration Complete", href: "#", status: "upcoming" },
];

export default function AddProperty() {
  const { accessToken } = useAuth();
  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();
  const { isComplete, propertyId, isSubaccountCreated } = location.state || {};
  const [propertyName, setPropertyName] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [reviewUrl, setReviewUrl] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [propertyEmail, setPropertyEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [businessType, setBusinessType] = useState("hotel");
  const [about, setAbout] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [country, setCountry] = useState("");
  const [iso2, setIso2] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [address, setAddress] = useState("");
  const [standardCheckinTime, setStandardCheckinTime] = useState("");
  const [standardCheckoutTime, setStandardCheckoutTime] = useState("");
  const [timezone, setTimezone] = useState("");
  const [defaultNewDayTime, setDefaultNewDayTime] = useState("");
  const [logo, setLogo] = useState(null);
  const [cover, setCover] = useState(null);
  const [logoName, setLogoName] = useState("");
  const [coverName, setCoverName] = useState("");
  const [firstForm, setFirstForm] = useState(true);
  const [secondForm, setSecondForm] = useState(false);
  const [thirdForm, setThirdForm] = useState(false);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState();
  const [loading, setLoading] = useState(false);
  const [timezones, setTimezones] = useState([]);
  const [phoneBuy, setPhoneBuy] = useState(
    phoneNumbers.length > 0 ? phoneNumbers[0].phoneNumber : ""
  );
  const [logoUrl, setLogoUrl] = useState(null);
  const [coverUrl, setCoverUrl] = useState(null);
  const [nextContact, setNextContact] = useState(false);
  const [disableChange, setDisableChange] = useState(false);
  const [property, setProperty] = useState();
  const [countries, setCountries] = useState([]);
  const [propertyData, setPropertyData] = useState(null);
  const [mode, setMode] = useState("buy"); // "buy" | "host"
  const [initialRating, setInitialRating] = useState(null);

  useEffect(() => {
    if (isComplete === false) {
      const fetchData = async () => {
        setFirstForm(false);
        setSecondForm(false);
        setThirdForm(true);

        await fetchPropertyData(); // Await the fetchPropertyData function
      };

      fetchData(); // Call the async function
    }
  }, [isComplete]);

  console.log("phoneBuy", phoneBuy);
  const fetchPropertyData = async () => {
    try {
      const response = await apiClient.get(`${baseUrl}/property/${propertyId}`);
      if (response.ok) {
        const newToken = response.headers.get("Authorization");
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
        }
      }
      console.log(response);

      const { _, setting } = response.data.result;
      const property = response.data.result.property.property;
      console.log(property);

      // Map the fetched data to your state variables
      setPropertyName(property.name || "");
      setPropertyEmail(property.email || "");
      setPhoneNumber(property.phoneNumber || "");
      setWebsite(property.website || "");
      setBusinessType(property.businessType || "hotel");
      setAbout(property.about || "");
      setCountry(property.country || "");
      setState(property.state || "");
      setCity(property.city || "");
      setAddress(property.address || "");
      setZipcode(property.zipcode || "");
      setCountryCode(property.countryCode || "");
      setLogo(property.logoUrl || null);
      setCover(property.coverUrl || null);
      setStandardCheckinTime(setting.standardCheckinTime || "");
      setStandardCheckoutTime(setting.standardCheckoutTime || "");
      setTimezone(setting.timezone || "");
      setLogoUrl(property.logoUrl || null);
      setCoverUrl(property.coverUrl || null);
      setDefaultNewDayTime(setting.defaultNewDayTime || "");
      setPropertyData(response.data);
      setProperty(property);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error fetching property data.";
      console.log(error);
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    if (iso2) {
      console.log("helo", iso2);
      //fetchPhoneNumbers();
    }
  }, [iso2]);
  useEffect(() => {
    if (!isTyping) return; // ⬅ block backend/programmatic updates

    const timeout = setTimeout(() => {
      if (propertyName.length >= 4) {
        handleSearch(propertyName);
      } else {
        setSuggestions([]);
      }
    }, 400);

    return () => clearTimeout(timeout);
  }, [propertyName, isTyping]);

  const handleSearch = async (value) => {
    setPropertyName(value);

    if (value.length < 4) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await apiClient.get(
        `${baseUrl}/property/search?query=${encodeURIComponent(value)}`
      );

      if (response.data.result.length) {
        setSuggestions(response.data.result);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Error search:", error);
    }
  };

  const handleSelect = async (place) => {
    console.log("Selected place:", place);
    setIsTyping(false);
    setPropertyName(place.description);
    setSuggestions([]);
    try {
      const response = await apiClient.get(
        `${baseUrl}/property/details?place_id=${place.place_id}`
      );

      console.log("Full business details:", response);

      const data = response.data.result;

      // Fill in the form fields with the selected business details
      setPropertyName(data?.name || "");
      setWebsite(data?.website || "");
      setAbout(data?.editorial_summary?.overview || "");
      setCountry(data?.parsedAddress?.country || "");
      setIso2(data?.parsedAddress?.countryCode || "");

      setState(data?.parsedAddress?.state || "");
      setCity(data?.parsedAddress?.city || "");
      setZipcode(data?.parsedAddress?.zipcode || "");
      setAddress(data?.formatted_address || "");
      setBusinessType(data?.businessType || "hotel");
      setReviewUrl(data?.url || "");
      setInitialRating(data?.rating || "");
      if (data?.international_phone_number) {
        const intlPhone = data.international_phone_number;
        const phoneCode = intlPhone.match(/^\+?\d+/)?.[0] || "";
        const phoneNumber = intlPhone.replace(phoneCode, "").trim();

        setCountryCode(phoneCode); // ex: +91

        setPhoneNumber(normalizePhone(phoneNumber)); // ex: 98765 43210
      }
    } catch (error) {
      console.error("Error fetching business details:", error);
    }
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    const selectedCountryIso2 =
      countries.find((countryItem) => countryItem.name === selectedCountry)
        ?.iso2 || "";
    setCountry(selectedCountry);
    setIso2(selectedCountryIso2);
  };
  const handleDropLogoFile = (e) => {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      if (newFiles[0].type.startsWith("image/") === false) {
        alert("Please upload a valid image file");
        return;
      }
      if (newFiles[0].size > 10 * 1024 * 1024) {
        alert("Please upload a file smaller than 10MB");
        return;
      }
      setLogoUrl(URL.createObjectURL(newFiles[0]));
      setLogo(newFiles[0]);
      setLogoName(newFiles[0]?.name || "");
    }
  };
  const handleDropCoverFile = (e) => {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      if (newFiles[0].type.startsWith("image/") === false) {
        alert("Please upload a valid image file");
        return;
      }
      if (newFiles[0].size > 10 * 1024 * 1024) {
        alert("Please upload a file smaller than 10MB");
        return;
      }
      setCoverUrl(URL.createObjectURL(newFiles[0]));
      setCover(newFiles[0]);
      setCoverName(newFiles[0]?.name || "");
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await apiClient.get(`${baseUrl}/country`);

      setCountries(response.data.result.countries);
      if (property && property.country) {
        console.log("here");
        const iso2 = countries.find(
          (countryItem) => countryItem.name === property.country
        )?.iso2;
        setIso2(iso2);
      }
    } catch (error) {
      console.log(error);
      const errorMessage =
        error.response?.data?.message || "Error fetching countries.";
      toast.error(errorMessage);
      console.error("Error fetching countries:", errorMessage);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, [accessToken, property]);

  const navigate = useNavigate();
  // property onboard api call
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!logo) {
      toast.error("Please upload a logo");
      return;
    }

    setLoading(true); // Set loading state to true when form submission starts
    const url = `${baseUrl}/property/checkEmailExists`;
    const response = await apiClient.post(url, {
      email: propertyEmail,
    });
    if (response.data.result.exists) {
      toast.error("Email already exists. Please use a different email.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", propertyName);
    if (propertyEmail) formData.append("email", propertyEmail);
    formData.append("website", website);
    formData.append("businessType", businessType || "hotel");
    formData.append("reviewUrl", reviewUrl);
    // formData.append("about", about);
    if (about !== "") formData.append("about", about);
    formData.append("phoneNumber", normalizePhone(phoneNumber));
    formData.append("initialRating", initialRating);
    formData.append("countryCode", countryCode);
    formData.append("country", country);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("zipcode", zipcode);
    formData.append("address", address);
    formData.append("standardCheckinTime", standardCheckinTime);
    formData.append("standardCheckoutTime", standardCheckoutTime);
    formData.append("timezone", timezone);
    formData.append("defaultNewDayTime", defaultNewDayTime);
    if (logo) formData.append("logo", logo);
    if (cover) formData.append("cover", cover);

    try {
      let response;

      if (isComplete === false) {
        // Update existing property
        response = await apiClient.put(
          `${baseUrl}/property/${propertyId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${accessToken}`,
            },
            withCredentials: true,
          }
        );
        if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
          }
        }
        toast.success("Property updated successfully!");
        setProperty(response.data.result.property);
        setSecondForm(false);
        setThirdForm(true);
      } else {
        // Create a new property
        response = await apiClient.post(`${baseUrl}/property`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
          withCredentials: true,
        });

        toast.success("Property added successfully!");
        setProperty(response.data.result.property);
        navigate("/propertyhome");
      }

      console.log(
        isComplete === false ? "Updated property" : "Added property",
        response.data
      );
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error in Property details";
      toast.error(errorMessage);
      console.error("Error:", errorMessage);
    } finally {
      setLoading(false); // Set loading state to false after the API call completes or fails
    }
  };

  const phoneRegex = /^\d{10}$/;

  const handleNextContact = () => {
    setNextContact(true);
  };

  const handleNextButton1 = async (e) => {
    e.preventDefault();
    try {
      const url = `${baseUrl}/property/checkEmailExists`;
      const response = await apiClient.post(url, {
        email: propertyEmail,
      });
      if (response.data.result.exists) {
        toast.error("Email already exists. Please use a different email.");
        return;
      }
    } catch (e) {
      console.error(e);
    }
  };
  const deleteLogo = () => {
    setLogo(null);
    setLogoUrl(null);
    setLogoName("");
  };
  const deleteCover = () => {
    setCover(null);
    setCoverUrl(null);
    setCoverName("");
  };

  const handleBackButton1 = async () => {
    setFirstForm(true);
    setSecondForm(false);
  };
  const handleBackButton2 = () => {
    setSecondForm(true);
    setThirdForm(false);
  };

  const handleTimezoneChange = (e) => {
    const selectedIndex = e.target.selectedIndex; // Get the index of the selected option
    const selectedOption = e.target.options[selectedIndex].text; // Get the text of the selected option

    setTimezone(selectedOption);
  };

  function normalizePhone(input) {
    if (!input) return "";
    return String(input).replace(/[^\d]/g, "");
  }

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="space-y-4 md:space-y-10 min-h-screen divide-y bg-gray-300 divide-gray-900/10">
        <div className="grid grid-cols-1 gap-y-4 md:gap-y-8 md:grid-cols-3">
          {/* right side */}
          <div className="flex flex-col items-left justify-top md:col-span-1 p-4 md:p-6 m-4 md:m-20 rounded-lg mt-8 md:mt-40 space-y-4 md:space-y-6">
            <h2 className="text-3xl md:text-5xl font-black text-black">
              Welcome Onboard!
            </h2>
            <p className="mt-2 md:mt-4 text-base md:text-xl text-black ">
              We are few steps away to get started.
            </p>
            {/**{firstForm && (
							<p className="mt-2 text-sm md:text-base text-black font-bold">
								Page 1/3
							</p>
						)}
						{secondForm && (
							<p className="mt-2 text-sm md:text-base text-black font-bold">
								Page 2/3
							</p>
						)}
						{thirdForm && (
							<p className="mt-2 text-sm md:text-base text-black font-bold">
								Page 3/3
							</p>
						)}**/}
          </div>

          {/* left side */}
          <form
            className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 m-4 md:m-10 rounded-b-xl"
            onSubmit={handleSubmit}
            // onClick={}
          >
            <div className="px-4 py-4 sm:py-6 sm:p-8">
              {/* form heading */}
              <div className="mb-4">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                  Business Profile
                </h2>
                <p className="mt-2 text-sm md:text-base text-gray-600">
                  This information will be displayed publicly so be careful what
                  you share.
                </p>
              </div>

              <div className="grid max-w grid-cols-1 gap-x-6 gap-y-6 sm:gap-y-8 sm:grid-cols-6">
                {/* Property Name and Email */}

                <div className="sm:col-span-3 relative">
                  <label
                    htmlFor="property-name"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    Business Name
                  </label>

                  <div className="mt-2">
                    <input
                      id="property-name"
                      name="property-name"
                      type="text"
                      required
                      value={propertyName}
                      onChange={(e) => {
                        setIsTyping(true);
                        setPropertyName(e.target.value);
                      }}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setTimeout(() => setIsFocused(false), 150)}
                      placeholder="Search your business on Google"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                    />
                  </div>

                  {/* Suggestion dropdown */}
                  {isFocused && suggestions.length > 0 && (
                    <ul className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
                      {suggestions.map((s, i) => (
                        <li
                          key={i}
                          onMouseDown={() => handleSelect(s)}
                          className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                        >
                          <div className="font-medium">
                            {s.structured_formatting.main_text}
                          </div>
                          <div className="text-sm text-gray-500">
                            {s.structured_formatting.secondary_text}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="property-email"
                    className="block text-sm font-medium  mb-2 text-gray-700"
                  >
                    Business Email Address
                  </label>
                  <div className="mt-2">
                    <input
                      id="property-email"
                      name="property-email"
                      type="email"
                      value={propertyEmail}
                      onChange={(e) => setPropertyEmail(e.target.value)}
                      placeholder="Enter Business email"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                    />
                  </div>
                </div>

                {/* Property Phone Number */}
                <div className="sm:col-span-3">
                  <label
                    htmlFor="property-phone-number"
                    className="block text-sm font-medium  mb-2 text-gray-700"
                  >
                    Business Phone Number
                  </label>
                  <div className="flex flex-row mt-2">
                    <select
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                      className="rounded-l-md border-r-0 border-gray-300 py-2 pl-3 pr-8 focus:border-indigo-500 focus:ring-indigo-500 text-sm min-w-[80px] flex-shrink-0"
                    >
                      <option value="+1">+1</option>
                      <option value="+91">+91</option>
                      <option value="+44">+44</option>
                      <option value="+61">+61</option>
                      {/* Add more country codes as needed */}
                    </select>
                    <input
                      id="property-phone-number"
                      name="property-phone-number"
                      type="tel"
                      required
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Phone number"
                      className="block flex-1 rounded-r-md border-l-0 border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                      minLength="10"
                      maxLength="10"
                      pattern="[0-9]*"
                    />
                  </div>
                </div>

                {/* Property Official Website */}
                <div className="sm:col-span-3">
                  <label
                    htmlFor="website"
                    className="block text-sm font-medium  mb-2 text-gray-700"
                  >
                    Business Official Website
                  </label>
                  <div className="mt-2">
                    <input
                      id="website"
                      name="website"
                      type="url"
                      required
                      value={website}
                      onChange={(e) => {
                        setWebsite(e.target.value);
                        e.target.setCustomValidity("");
                      }}
                      placeholder="Enter Business official website"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                      onInvalid={(e) => {
                        if (!e.target.value) {
                          e.target.setCustomValidity(
                            "Please enter the Business website URL."
                          );
                        } else {
                          e.target.setCustomValidity(
                            "Please enter a valid URL (example: https://example.com)"
                          );
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="businessType"
                    className="block text-sm font-medium  mb-2 text-gray-700"
                  >
                    Business Type
                  </label>
                  <div className="mt-2">
                    <select
                      value={businessType}
                      onChange={(e) => setBusinessType(e.target.value)}
                      className="block w-full border border-gray-300 rounded-md px-3 py-2 text-base focus:border-indigo-500 focus:ring-indigo-500 text-black text-[13px] placeholder:text-black placeholder:font-light"
                    >
                      <option value="">Select a business type</option>
                      {BUSINESS_TYPES.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="sm:col-span-3">
                  <label
                    htmlFor="reviewUrl"
                    className="block text-sm font-medium  mb-2 text-gray-700"
                  >
                    Google Review URL
                  </label>
                  <div className="mt-2">
                    <input
                      id="reviewUrl"
                      name="reviewUrl"
                      type="url"
                      required
                      value={reviewUrl}
                      onChange={(e) => {
                        setReviewUrl(e.target.value);
                        e.target.setCustomValidity("");
                      }}
                      placeholder="Enter Google Review URL"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                      onInvalid={(e) => {
                        if (!e.target.value) {
                          e.target.setCustomValidity(
                            "Please enter the Google Review URL."
                          );
                        } else {
                          e.target.setCustomValidity(
                            "Please enter a valid URL"
                          );
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="sm:col-span-3">
                  <label
                    htmlFor="rating"
                    className="block text-sm font-medium  mb-2 text-gray-700"
                  >
                    Google Rating
                  </label>
                  <div className="mt-2">
                    <input
                      id="rating"
                      name="rating"
                      type="number"
                      required
                      value={initialRating}
                      onChange={(e) => {
                        setInitialRating(e.target.value);
                        e.target.setCustomValidity("");
                      }}
                      placeholder="Enter Google Rating"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                      onInvalid={(e) => {
                        if (!e.target.value) {
                          e.target.setCustomValidity(
                            "Please enter the Google Rating"
                          );
                        } else {
                          e.target.setCustomValidity(
                            "Please enter the google rating"
                          );
                        }
                      }}
                    />
                  </div>
                </div>

                {/* About */}
                <div className="col-span-full">
                  <label
                    htmlFor="about"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    About
                  </label>
                  <div className="mt-2">
                    <textarea
                      id="about"
                      name="about"
                      rows={3}
                      value={about}
                      // required
                      onChange={(e) => setAbout(e.target.value)}
                      className="block w-full rounded-md border rows-2 border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                      placeholder="Wrtie something"
                    />
                  </div>
                </div>

                {/* Logo photo */}
                <div
                  className="col-span-full sm:col-span-2"
                  onDrop={handleDropLogoFile}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <label
                    htmlFor="Logo"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    Logo
                  </label>
                  <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-4 sm:px-6 py-6 sm:py-10">
                    <div className="text-center">
                      {logoUrl ? (
                        <img
                          src={logoUrl}
                          className="max-w-full h-auto max-h-32 sm:max-h-48"
                        />
                      ) : (
                        <PhotoIcon
                          aria-hidden="true"
                          className="mx-auto h-8 w-8 sm:h-10 sm:w-10 text-gray-300"
                        />
                      )}
                      <div className="mt-4 flex flex-col sm:flex-row items-center justify-center text-sm leading-6 text-gray-600">
                        <label
                          htmlFor="logo-upload"
                          className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                        >
                          <span className="text-right">Upload a file</span>
                          <input
                            id="logo-upload"
                            name="logo-upload"
                            type="file"
                            onChange={(e) => {
                              if (e.target.files[0]) {
                                if (e.target.files[0].size > 10 * 1024 * 1024) {
                                  alert(
                                    "Please upload a file smaller than 10MB"
                                  );
                                  return;
                                }
                                setLogoUrl(
                                  URL.createObjectURL(e.target.files[0])
                                );
                                setLogo(e.target.files[0]);
                                setLogoName(e.target.files[0]?.name || "");
                              }
                            }}
                            className="sr-only"
                          />
                        </label>
                      </div>
                      <p className="text-xs leading-5 text-gray-600 mt-2">
                        PNG, JPG, GIF up to 10MB
                      </p>
                      {logoName && (
                        <p className="text-xs leading-5 text-green-600 mt-2">
                          {logoName}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Cover photo */}
                <div
                  className="col-span-full sm:col-span-4"
                  onDrop={handleDropCoverFile}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <label
                    htmlFor="cover-photo"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    Cover photo
                  </label>
                  <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-4 sm:px-6 py-6 sm:py-10">
                    <div className="text-center w-full">
                      {coverUrl ? (
                        <img
                          src={coverUrl}
                          className="max-w-full h-auto max-h-32 sm:max-h-48"
                        />
                      ) : (
                        <PhotoIcon
                          aria-hidden="true"
                          className="mx-auto h-8 w-8 sm:h-10 sm:w-10 text-gray-300"
                        />
                      )}
                      <div className="mt-4 flex flex-col sm:flex-row items-center justify-center text-sm leading-6 text-gray-600">
                        <label
                          htmlFor="cover-upload"
                          className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                        >
                          <span>Upload a file</span>
                          <input
                            id="cover-upload"
                            name="cover-upload"
                            type="file"
                            onChange={(e) => {
                              const file = e.target.files[0];

                              if (file) {
                                if (file.size > 10 * 1024 * 1024) {
                                  alert(
                                    "Please upload a file smaller than 10MB"
                                  );
                                  return;
                                }
                                setCoverUrl(URL.createObjectURL(file));
                                setCover(file);
                                setCoverName(file.name || "");
                              }
                            }}
                            className="sr-only"
                          />
                        </label>
                        <p className="pl-0 sm:pl-1 mt-1 sm:mt-0">
                          or drag and drop
                        </p>
                      </div>
                      <p className="text-xs leading-5 text-gray-600 mt-2">
                        PNG, JPG, GIF up to 10MB
                      </p>

                      {coverName && (
                        <div className="flex items-center justify-center gap-4 mt-2">
                          <span className="text-xs leading-5 text-green-600">
                            {coverName}
                          </span>
                          <span
                            onClick={deleteCover}
                            className="cursor-pointer"
                          >
                            <TrashIcon className="w-4 h-4" />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-4 py-4 sm:py-6 sm:p-8">
              {/* form heading */}

              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-6 sm:gap-y-8 sm:grid-cols-6">
                {/* Country */}
                <div className="sm:col-span-3">
                  <label
                    htmlFor="country"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    Country
                  </label>
                  <div className="mt-2">
                    <select
                      id="country"
                      name="country"
                      value={country}
                      required
                      onChange={handleCountryChange}
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                    >
                      <option value="">Select a country</option>
                      {countries.map((countryItem) => (
                        <option key={countryItem.iso2} value={countryItem.name}>
                          {countryItem.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Zipcode */}
                <div className="sm:col-span-3">
                  <label
                    htmlFor="zipcode"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    Zipcode
                  </label>
                  <div className="mt-2">
                    <input
                      id="zipcode"
                      name="zipcode"
                      type="text"
                      value={zipcode}
                      required
                      onChange={(e) => setZipcode(e.target.value)}
                      placeholder="Enter zipcode"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                      minLength="5"
                      maxLength="6"
                    />
                  </div>
                </div>

                {/* State */}
                <div className="sm:col-span-3">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    State
                  </label>
                  <div className="mt-2">
                    <input
                      id="state"
                      name="state"
                      type="text"
                      value={state}
                      required
                      onChange={(e) => setState(e.target.value)}
                      placeholder="Enter state"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                    />
                  </div>
                </div>

                {/* City */}
                <div className="sm:col-span-3">
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    City
                  </label>
                  <div className="mt-2">
                    <input
                      id="city"
                      name="city"
                      type="text"
                      value={city}
                      required
                      onChange={(e) => setCity(e.target.value)}
                      placeholder="Enter city"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                    />
                  </div>
                </div>

                {/* Address */}
                <div className="sm:col-span-full">
                  <label
                    htmlFor="address"
                    className="block text-sm font-medium mb-2 text-gray-700"
                  >
                    Address
                  </label>
                  <div className="mt-2">
                    <input
                      id="address"
                      name="address"
                      type="text"
                      required
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Enter address"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col-reverse sm:flex-row items-stretch sm:items-end justify-end gap-3 sm:gap-x-6 border-t border-gray-900/10 bg-gray-100 px-4 py-4 sm:px-8 rounded-b-xl">
              <button
                type="button"
                onClick={handleBackButton1} // Add a handler for the previous button
                className="w-full sm:w-auto rounded-md bg-gray-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
              >
                Previous
              </button>
              <button
                type="submit"
                // onClick={handleNextButton2}
                className="w-full sm:w-auto rounded-md bg-indigo-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Save and Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
